import React from 'react'
import styled from '@emotion/styled'
import { css } from '@emotion/core'
import { FormattedMessage } from 'react-intl'

// components
import { Title3 } from 'components/Titles'
import SelectPresets from 'components/SelectPresets'
import SelectPopulation from 'components/SelectPopulation'
import Search from 'components/Search'
import Link from 'components/Links'

import logo from './logo.svg'

const Container = styled.div(({ theme }) => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${theme.white};
  color: ${theme.blueElectric};
  height: 60px;
  padding: 0 15px;
`)

const Left = styled.div`
  display: flex;
  align-items: center;
`

const Right = styled.div`
  display: flex;
  align-self: stretch;
`

const LogoLinkg = styled(Link)`
  display: flex;
  align-items: center;
  color: inherit;
`

const Logo = styled.img(({ theme }) => css`
  padding-right: 20px;
  border-right: 1px solid ${theme.tonic};
`)

const Title = styled(Title3)`
  padding-left: 20px;
`

const TopBar = (props) => {
  return (
    <Container>
      <Left>
        <LogoLinkg to='/'>
          <Logo src={logo} />
          <Title>
            <FormattedMessage id='home-title' />
          </Title>
        </LogoLinkg>
      </Left>
      <Right>
         {/*<SelectPresets />
        <SelectPopulation />
        <Search />*/}
      </Right>
    </Container>
  )
}

export default TopBar
